import CollectionBase from 'common/base/collection-base';
import FacilityModel from 'common/models/facility-model';
import {t} from 'common/utils/translation-util';

export default CollectionBase.extend({
  getFacility() {
    if (this.models) {
      // JSON provided directly, did not fetch
      return this.models[0].attributes;
    }
    return this.getAttribute('building');
  },
  initialize() {
    this.errorMessage = t('Facility data failed to load.');
    this.model = FacilityModel;
  },
});
